// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"notification_closeButton__P6Sr_","mantine-Notifications-notification":"notification_mantine-Notifications-notification__peiqK"};